export const householdOutgoingsQuestions: Record<string, any> = {
  childcare: {
    labelKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.childcare.label',
    booleanQuestionFormKey: 'hasChildcare',
    adornmentKey: 'common.monthly',
    explanationKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.childcare.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  maintenance: {
    labelKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.maintenance.label',
    booleanQuestionFormKey: 'hasMaintenance',
    adornmentKey: 'common.monthly',
    explanationKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.maintenance.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  educationFees: {
    labelKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.educationFees.label',
    booleanQuestionFormKey: 'hasEducationFees',
    adornmentKey: 'common.monthly',
    explanationKey: 'applicationForm.HOUSEHOLD_OUTGOINGS.educationFees.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
